/**
 * Capitalize the first letter of every word.
 * Preserves existing uppercase letters (e.g. "AI" stays "AI").
 * "john doe"  → "John Doe"
 * "hank"      → "Hank"
 * "python 101"→ "Python 101"
 */
export function toTitleCase(str) {
  if (!str) return '';
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
